






































import { Box, SecondaryButton, Flex, Button, InputError, BaseModal } from '../../atoms'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { InputGroup } from '../../molecules'
import { DISPLAY_NAME_LIMIT } from '../../../utils/field-length'
import { CHANGE_DISPLAY_NAME, PROFILE_MODULE } from '../../../store/modules/profile/constant'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

@Component({
  components: {
    Box,
    SecondaryButton,
    Flex,
    InputGroup,
    Button,
    InputError,
    BaseModal
  },
  methods: {
    ...mapActions(PROFILE_MODULE, [CHANGE_DISPLAY_NAME])
  },
  validations: {
    txtDisplayName: {
      required
    }
  }
})
export default class DisplayNameBox extends Vue {
  @Prop({ required: false, type: String }) displayName!: string
  txtDisplayName = this.displayName
  changeDisplayNameToggle = false
  textDisabled = true
  errorMsg = ''
  modalVisibleSuccess = false

  @Watch('displayName')
  ondisplayName() {
    this.txtDisplayName = this.displayName
  }
  @Watch('txtDisplayName')
  ontxtDisplayName() {
    this.$v.txtDisplayName.$touch()
  }

  get displayNameFieldLimit(): number{
    return DISPLAY_NAME_LIMIT
  }
  changeDisplayNameRequest(): void {
    this.changeDisplayNameToggle = !this.changeDisplayNameToggle
    this.textDisabled = !this.textDisabled
  }
  async changeDisplayNameSubmit() {
    if(this.changeDisplayNameError != "") {
      return
    }
    const resp = await (this as any)[CHANGE_DISPLAY_NAME](this.txtDisplayName)
    if (resp.code !== 200) {
      this.errorMsg = resp?.error_message
      return
    }
    this.modalVisibleSuccess = !this.modalVisibleSuccess
    this.changeDisplayNameRequest()
    this.errorMsg = ''
  }
  get changeDisplayNameError(): string {
    const { txtDisplayName } = this.$v
    if (txtDisplayName.$error) {
      if (!txtDisplayName.required) {
        return 'กรุณากรอกชื่อแสดงผล'
      }
    }
    return ''
  }
}
